import store from '@/store'
import router from '@/router'
import swal from '@/utils/sweetalertUtil'

/**
 * Configura el interceptor de respuesta para manejar errores 401
 * @param {AxiosInstance} axiosInstance - Instancia de axios a configurar
 */
export const setupResponseInterceptor = (axiosInstance) => {
  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        const isSessionCheck = error.config?.url?.includes('/session');
        const isLogoutRequest = error.config?.url?.includes('/logout');

        // No mostrar alerta ni redirigir si es petición de logout
        if (isLogoutRequest) {
          store.dispatch('auth/logoutLocalOnly')
          return Promise.reject(error);
        }
        store.dispatch('auth/logoutLocalOnly')
        
        // Mostrar alerta de sesión expirada solo si no es un chequeo de sesión
        if (!isSessionCheck) {
          swal.fire({
            html: 'Tu sesión ya no es válida'
          })
        }
        
        // Redirigir a landing solo si no estamos ya en esa ruta
        // Y evitar redirección si el error viene de verificar la sesión
        if (router.currentRoute.value.name !== 'landing-page' && !isSessionCheck) {
          sessionStorage.setItem('justLoggedOut', '1')
          router.push({ name: 'landing-page', query: router.currentRoute.value.query })
        }
      }
      
      return Promise.reject(error)
    }
  )
}
